import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent } from 'recompose';
import { get } from 'lodash';

import { getUserFullName } from 'modules/user/utils/user';
import { redirectTo } from 'modules/auth/actions/redirectAction';
import { getUsersReadPermissions } from 'modules/session/selectors/permissions';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { isConversationParticipant } from 'modules/appointmentInfo/selectors/currentAppointment';
import { startObserveUserUpdates, stopObserveUserUpdates } from 'modules/websocket/actions/userUpdates';
import { invokeEditUserModal } from 'modules/user/actions/invokeModals';

import Page404 from 'pages/Page404';
import UserProfilePage from './UserProfilePage';


const mapStateToProps = (state) => {
  const { firstName, lastName } = state.auth.userInfo.profile;

  return {
    userId: state.auth.userInfo.userId,
    userFullName: getUserFullName(firstName, lastName),
    userReadPermissions: getUsersReadPermissions(state),
    userIsOnCall: conferenceInProgress(state) && isConversationParticipant(state),
    isMyAccountFeatureEnabled: state.common.organizationConfig.generalConfig.isMyAccountFeatureEnabled,
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      startObserveUserUpdates,
      invokeEditUserModal,
    },
  ),
  lifecycle({
    componentDidMount() {
      const { userIsOnCall, userId, startObserveUserUpdates, isMyAccountFeatureEnabled, userReadPermissions } = this.props;
      const shouldInvokeEdit = get(this.props, 'match.params.action') === 'edit';

      if (userIsOnCall || ((!isMyAccountFeatureEnabled || !userReadPermissions.canSeeUserAccount) && shouldInvokeEdit)) {
        return setTimeout(() => redirectTo('/appointments'), 50);
      }

      startObserveUserUpdates([userId]);

      if (shouldInvokeEdit) this.props.invokeEditUserModal();
    },
    componentWillUnmount() {
      stopObserveUserUpdates();
    },
  }),
  branch(
    ({ isMyAccountFeatureEnabled, userReadPermissions }) => !isMyAccountFeatureEnabled || !userReadPermissions.canSeeUserAccount,
    renderComponent(Page404),
  ),
)(UserProfilePage);
